<template>
    <div class="hide_scroll" style="display: flex; gap: 15px; overflow-x: scroll; margin: 0 -12px; padding: 0 12px;">
        <div @click="showTrainingRequestDetail(each)" v-for="each, i in requestFormList" :key="i" style="flex-shrink: 0; display: flex; flex-direction: column; flex-basis: 251px; background-color: #F8FAFC; border: 1px solid #fed1a0; border-radius: 12px; padding: 12px; position: relative;">
            <div v-if="today === each.insert_date.split(' ')[0]" class="new_box">NEW</div>
            <div style="display: flex; align-items: center; gap: 10px;">
                <div>
                    <ProfileImage :imagePath="each.image_path" style="width: 35px;"></ProfileImage>
                </div>
                <div>
                    <div style="font-weight: 700; font-size: 12px; ">{{ each.nic_name }} <span style="font-weight: 900; margin-left: 2px; color: var(--color-main);">{{ each.position }}</span></div>
                    <div style="font-size: 12px; color: #808080; line-height: 16px; margin-top: 4px;">{{ each.insert_date | agoDateStr }}</div>
                </div>
            </div>
            <div style="flex: 1;">
                <div style="background-color: #fff; border: 1px solid #eff3f8; border-radius: 12px; margin-top: 13px; position: relative; padding: 13px;;">
                    <div style="position: absolute; top: -10px;">
                        <img style="width: 10px;" :src="require('@/assets/img/quotes.png')" alt="">
                    </div>
                    <div class="ellipsis" style="font-weight: 500; font-size: 12px; line-height: 18px;">{{ each.contents }}</div>
                </div>
            </div>
            <div style="margin-top: 5px; background-color: #210f03; height: 40px; line-height: 40px; text-align: center; border-radius: 12px; color: #fff; font-weight: 700; font-size: 12px;">요청서 확인하기</div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { MAIN_TYPE } from '@/Constants'
import moment from 'moment'

export default {
    name: "RecentJoinRequestWrapper",
    components: { ProfileImage },
    props: {
        requestFormList: {
            type: Array,
            default: () => {}
        }
    },
    data() {
        return {
            today: moment().format('YYYY-MM-DD')
        }
    },
    methods: {
        showTrainingRequestDetail(teamDetail) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_TEAM_JOINING, isModalBackTransparent: true, isExpert: true, soccerhowIdx: teamDetail.idx, isPopular: false, isRealTime: false })
        }
    },
    created() {
    }
}
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.new_box {
    border-top-right-radius: 12px; 
    border-bottom-left-radius: 12px; 
    background-color: #FFEACF; 
    position: absolute; 
    top: 0; 
    right: 0; 
    width: 51px; 
    text-align: center; 
    height: 29px; 
    line-height: 29px; 
    color: var(--color-main); 
    font-size: 12px; 
    font-weight: 700;
}
</style>